var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-preview',_vm._b({attrs:{"value":_vm.value,"placeholder":_vm.productPlaceholder || _vm.defaultPlaceholder}},'image-preview',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }